import { IIconProps } from "../types"

export default function IconLR7(props: IIconProps) {
  const width = props.size || props.width || 106
  const height = props.size || props.height || 75
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 106 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5755 2.45293C14.5655 1.53293 17.1055 0.692932 20.2555 0.492932C23.4155 0.302932 27.1955 0.752932 30.8755 1.44293C34.5455 2.12293 38.1255 3.03293 42.3955 3.71293C46.6555 4.40293 51.6055 4.85293 57.0755 4.69293C62.5455 4.53293 68.5355 3.75293 72.7655 3.19293C76.9955 2.64293 79.4755 2.32293 81.6555 2.74293C83.8355 3.16293 85.7255 4.33293 87.9655 5.31293C90.2155 6.29293 92.8155 7.07293 95.0655 7.82293C97.3155 8.56293 99.1955 9.28293 100.725 11.0429C102.255 12.8029 103.435 15.6029 104.205 18.6229C104.975 21.6529 105.345 24.9029 104.915 30.2029C104.495 35.5129 103.275 42.8729 102.445 48.8329C101.605 54.7929 101.155 59.3529 99.9455 62.7629C98.7455 66.1829 96.7955 68.4629 93.8955 70.0229C90.9955 71.5929 87.1555 72.4329 81.3655 72.9929C75.5655 73.5429 67.8155 73.8029 58.5455 73.9029C49.2655 74.0029 38.4555 73.9329 31.3255 73.7029C24.1955 73.4729 20.7455 73.0829 18.2455 72.4029C15.7355 71.7229 14.1755 70.7429 12.9655 69.5029C11.7655 68.2729 10.9155 66.7729 8.8055 60.8129C6.6855 54.8529 3.2955 44.4429 1.7055 37.5729C0.105502 30.7029 0.305502 27.3829 0.825502 24.2229C1.3455 21.0729 2.1955 18.0729 3.3955 14.9529C4.6055 11.8229 6.1655 8.57293 7.6655 6.45293C9.1555 4.33293 10.5955 3.36293 12.5755 2.45293Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M55.3853 5.70312C56.1653 16.5731 56.9453 27.4531 57.0753 33.2131C57.2053 38.9731 56.6853 39.6231 53.4253 41.7731C50.1753 43.9231 44.1853 47.5631 38.1953 51.2131"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M56.7539 38.1934C62.7439 41.2334 68.7339 44.2734 71.6639 45.8534C74.5839 47.4334 74.4539 47.5634 74.3239 47.5034C74.1939 47.4334 74.0639 47.1734 73.9339 46.9134"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
